/// <amd-module name="Dashboards/DashboardView/src/components/DashboardContentGuard" />
import * as React from "react";
import { connect } from "react-redux";

import { DashboardViewAwareState, ErrorState as ErrorMessageData } from "../model/DashboardViewState";
import { ErrorActions } from "../redux/actions/ErrorActions";
import * as Selectors from "../redux/selectors/Selectors";
import { ConnectedDashboardContent } from "./DashboardContent";
import { ErrorMessageBar } from "./ErrorMessageBar";

import { Page } from "VSSUI/Page";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

interface ConnectedDashboardContentGuardOwnProps {}

interface ConnectedDashboardContentGuardMappedProps {
    showLoading: boolean;
    errorMessage?: ErrorMessageData;
}

interface DashboardContentGuardProps extends ConnectedDashboardContentGuardOwnProps, ConnectedDashboardContentGuardMappedProps {}

/**
 * Displays loading spinner while dashboard is not yet loaded, and error message bar.
 * Protects the content to bypass the need to code paths for incomplete state.
 */
class DashboardContentGuard extends React.Component<DashboardContentGuardProps & typeof Actions> {
    public render(): JSX.Element | null {
        return (
            <Page className="absolute-fill">
                {this.props.showLoading && <Spinner className="absolute-fill" size={SpinnerSize.large} />}
                {this.props.errorMessage && (
                    <ErrorMessageBar
                        message={this.props.errorMessage.errorMessage}
                        showRefreshLink={this.props.errorMessage.showRefreshLink}
                        onDismiss={this.props.onDismissErrorMessage}
                    />
                )}
                {!this.props.showLoading && <ConnectedDashboardContent />}
            </Page>
        );
    }
}

const Actions = {
    onDismissErrorMessage: ErrorActions.dismissErrorMessage
};

function mapStateToProps(state: DashboardViewAwareState): ConnectedDashboardContentGuardMappedProps {
    return {
        showLoading: Selectors.showLoading(state),
        errorMessage: Selectors.getErrorMessageData(state)
    };
}

export const ConnectedDashboardContentGuard = connect(
    mapStateToProps,
    Actions
)(DashboardContentGuard);
